var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"footer"},[_c('div',{staticClass:"copyright"},[_vm._v("© "+_vm._s(_vm.year)+" Hunora.com")])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }